import React, { useEffect, useState } from "react";
import userimg from "../../assets/images/avatar.svg";
import star from "../../assets/images/star.svg";
import { jobService } from "services/job.service";
import RequestDetails from "components/Modals/Clientpanelpipup/RequestDetails";
import useCurrentUser from "hooks/useCurrentUser";

const BidList = ({ id, setActiveTab, setShowBids }) => {
    const { user } = useCurrentUser();
    const [data, setData] = useState([])
    const [show, setShow] = useState(false);
    const [selectedId, setSelectedId] = useState(null)
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const getClientBidList = async () => {
        try {
            const response = await jobService.jobBidList(id);
            setData(response?.data?.data);
        } catch (err) {
            console.error(err?.response?.data?.message);
        }
    };

    useEffect(() => {
        getClientBidList();
    }, [id]);

    const handleRequestDetails = (id) => {

        setSelectedId(id);
        handleShow();
    };

    const getJobAmount = (item) => {
        if (item?.pilotNegotiatedBidAmount) {
            return item?.pilotNegotiatedBidAmount;
        } else if (item?.clientNegotiatedBidAmount) {
            return item?.clientNegotiatedBidAmount;
        } else if (item?.pilotInitialBidAmount) {
            return item?.pilotInitialBidAmount;
        }
    }


    const getCardBG = (item) => {
        if (item?.clientNegotiatedBidAmount || item?.jobId?.status === 'PilotAssigned') {
            return 'skyblue-bg';
        }
        return 'bg-transparent';
    }

    return <>
        <h3 >Bid Requests</h3>
        <div className="blue-head text-white d-flex gap-2 flex-wrap justify-content-between align-items-center">
            <p className="mb-0">Total Bid Requests</p>
            <p className="mb-0">
                {data?.totalBids} {data?.totalBids === 1 ? "Bid" : "Bids"}
            </p>

        </div>
        <button style={{
            border: "0",
            outline: "0 ",
            background: "none",
            width: "100%",
            padding: "0 ",
        }}
        >
            <div >
                {data?.bids?.map((item, i) => {
                    return <>
                        <div className={`py-3 px-3 bid-request-div ${getCardBG(item)}`}>
                            <div
                                className={`d-flex align-items-start justify-content-between gap-2 mb-2 `}
                                onClick={() => handleRequestDetails(item._id)} key={item?._id}>
                                <div className="d-flex align-items-start gap-3">
                                    <div>
                                        <img src={item?.pilotId?.avatar ? `${user?.baseS3Url}${item?.pilotId?.avatar}` : userimg} alt="user" className={`round-img ${item?.pilotId?.avatar === '' ? 'filter-invert' : ''}`} />
                                    </div>
                                    <div className="mt-2">
                                        <h6 className="m-0">{item?.pilotId?.fullName}</h6>
                                        {<p className="mb-0" style={{ textAlign: 'left' }}>
                                            <img src={star} className="me-2" alt="" />{Math.round(item?.pilotId?.avgRating)} Rating
                                        </p>}
                                    </div>
                                </div>
                                <div >
                                    <p className="mb-0 bid-text-ligght">Bid Amount</p>
                                    <p className="amount-color">{item?.pilotInitialBidAmount}</p>
                                </div>
                            </div>
                            <div className="bid-list-amount-history">
                                {item?.clientNegotiatedBidAmount && <div className="d-flex justify-content-between  p-0">
                                    <p>User Negotiation Amount ($)</p>
                                    <p className="amount-color">{item?.clientNegotiatedBidAmount}</p>
                                </div>}
                                {item?.pilotNegotiatedBidAmount && <div className="d-flex justify-content-between  p-0">
                                    <p>Pilot Negotiation Amount ($)</p>
                                    <p className="amount-color">{item?.pilotNegotiatedBidAmount}</p>
                                </div>}
                                {item?.status && <div className="d-flex justify-content-between  p-0">
                                    <p>Status</p>
                                    <p className="amount-color">  {item?.status === 'RejectedByClient' ? 'Rejected' : item?.status}</p>
                                </div>}
                            </div>


                        </div>

                    </>
                })}
            </div>
        </button>
        <RequestDetails dataId={selectedId} show={show} handleClose={handleClose} setActiveTab={setActiveTab} setShowBids={setShowBids} />
    </>
}

export default BidList;